var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye ON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 12.5C10.663 12.5 11.2989 12.2366 11.7678 11.7678C12.2366 11.2989 12.5 10.663 12.5 10C12.5 9.33696 12.2366 8.70107 11.7678 8.23223C11.2989 7.76339 10.663 7.5 10 7.5C9.33696 7.5 8.70107 7.76339 8.23223 8.23223C7.76339 8.70107 7.5 9.33696 7.5 10C7.5 10.663 7.76339 11.2989 8.23223 11.7678C8.70107 12.2366 9.33696 12.5 10 12.5Z",
    fill: "#06070D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.10264 9.53917C2.34264 5.81333 5.85681 3.125 10.001 3.125C14.1426 3.125 17.6551 5.81083 18.8968 9.53333C18.9968 9.835 18.9968 10.16 18.8968 10.4608C17.6576 14.1867 14.1426 16.875 9.99931 16.875C5.85764 16.875 2.34431 14.1892 1.10348 10.4667C1.00327 10.1656 1.00327 9.84021 1.10348 9.53917H1.10264ZM14.3751 10C14.3751 11.1603 13.9142 12.2731 13.0937 13.0936C12.2733 13.9141 11.1605 14.375 10.0001 14.375C8.83982 14.375 7.72702 13.9141 6.90655 13.0936C6.08608 12.2731 5.62514 11.1603 5.62514 10C5.62514 8.83968 6.08608 7.72688 6.90655 6.90641C7.72702 6.08594 8.83982 5.625 10.0001 5.625C11.1605 5.625 12.2733 6.08594 13.0937 6.90641C13.9142 7.72688 14.3751 8.83968 14.3751 10Z",
    fill: "#06070D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.e712e6edc47149373f76539741e719e6.svg";
export { ForwardRef as ReactComponent };